// extracted by mini-css-extract-plugin
export default {"DescriptionSection":"styles_DescriptionSection__DGGN-","content":"styles_content__WlKy3"};